// 多页签与新批次共用两个槽位；取消只废弃响应，不能撤销已经发出的外部查询。
let inFlight = 0
const waiting = []

function normalizeVehicles(vehicles) {
  const result = new Map()
  vehicles.forEach(vehicle => {
    const vehicleNo = String(vehicle.vehicleNo || '').trim().toUpperCase()
    const plateColor = String(vehicle.plateColor == null ? '' : vehicle.plateColor)
    if (!vehicleNo || vehicleNo.length > 20 || /[\s_,]/.test(vehicleNo)) throw new Error('车牌号须为1—20字符，不能含空白、逗号或下划线')
    if (!['1', '2', '3'].includes(plateColor)) throw new Error('请选择合法车牌颜色')
    const key = `${vehicleNo}_${plateColor}`
    if (!result.has(key)) result.set(key, { vehicleNo, plateColor, key })
  })
  if (!result.size || result.size > 20) throw new Error('每批须为1—20辆车（按车牌和颜色去重）')
  return Array.from(result.values())
}

function createVehicleMonitoringSession(query) {
  const state = {
    items: [], generation: 0, running: false,
    cancel() {
      this.generation++
      this.running = false
      this.items.forEach(item => { if (['PENDING', 'LOADING'].includes(item.status)) item.status = 'CANCELED' })
    },
    async start(vehicles) {
      const normalized = normalizeVehicles(vehicles)
      this.cancel()
      const generation = this.generation
      this.items = normalized.map(vehicle => ({ ...vehicle, status: 'PENDING', result: null, message: '', retries: 0 }))
      this.running = true
      let cursor = 0
      const worker = async () => {
        while (generation === this.generation && cursor < this.items.length) await this.execute(this.items[cursor++], generation)
      }
      await Promise.all([worker(), worker()])
      if (generation === this.generation) this.running = false
    },
    async execute(item, generation) {
      if (inFlight < 2) inFlight++
      else await new Promise(resolve => waiting.push(resolve))
      try {
        if (generation !== this.generation) return
        item.status = 'LOADING'
        item.message = ''
        const result = await query(item)
        if (generation !== this.generation) return
        item.result = result
        item.status = result.resultStatus || result.networkStatus || 'SUCCESS'
        item.message = result.message || ''
      } catch (error) {
        if (generation !== this.generation) return
        item.status = 'FAILED'
        item.message = error.message || error.msg || '查询失败'
      } finally {
        if (waiting.length) waiting.shift()()
        else inFlight--
      }
    },
    async retry(key) {
      const item = this.items.find(vehicle => vehicle.key === key)
      if (this.running || !item || item.status !== 'FAILED' || item.retries) return
      item.retries++
      this.running = true
      const generation = this.generation
      await this.execute(item, generation)
      if (generation === this.generation) this.running = false
    }
  }
  return state
}

function validateTrackTimeRange(startTime, endTime, now = Date.now()) {
  if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime <= startTime || endTime > now) throw new Error('区间须为有效时间且结束不晚于现在')
  const shanghai = new Date(now + 8 * 3600000)
  const monthStart = new Date(Date.UTC(shanghai.getUTCFullYear(), shanghai.getUTCMonth() - 6, 1))
  const monthEnd = new Date(Date.UTC(monthStart.getUTCFullYear(), monthStart.getUTCMonth() + 1, 0))
  const earliest = Date.UTC(monthStart.getUTCFullYear(), monthStart.getUTCMonth(), Math.min(shanghai.getUTCDate(), monthEnd.getUTCDate()), shanghai.getUTCHours(), shanghai.getUTCMinutes(), shanghai.getUTCSeconds(), shanghai.getUTCMilliseconds()) - 8 * 3600000
  if (startTime < earliest) throw new Error('历史开始须在近6自然月内（上海时区）')
  if (endTime - startTime > 72 * 3600000) throw new Error('历史区间不能超过72小时')
  return { startTime, endTime }
}

module.exports = { normalizeVehicles, createVehicleMonitoringSession, validateTrackTimeRange }
